module.exports = __webpack_public_path__ + "img/nav-design-halfsize.a3b875b.jpg";